export const Layout = {
  DEFAULT: 'DEFAULT',
  TEST: 'TEST',
};

export const LayoutOptions = [
  { key: Layout.DEFAULT, value: Layout.DEFAULT, text: 'Default' },
  { key: Layout.TEST, value: Layout.TEST, text: 'Test' },
];
